(function () {
  const _s = {
    currentItemCount: 0,
    cartShareUrl: '',
    validated: true,
    openField: '',
    isOpenDiscountCodeMainCart: false,
    isCopiedCart: false,
    pendingUpdates: 0,
  };

  function _dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  }

  function initCartIconFallback() {
    const cartIcon = document.getElementById('cart-icon');
    if (!cartIcon) return;

    const handleCartClick = (e) => {
      e.preventDefault();

      const isDrawerEnabled = window.Maximize?.isEnableCartDrawer;

      if (isDrawerEnabled) {
        const cartDrawerEl = document.getElementById('CartDrawer');

        if (cartDrawerEl) {
          cartDrawerEl.isOpen = true;

          document
            .getElementById('CartDrawer__Wrapper')
            ?.classList.add('is-visible');

          if (cartDrawerEl._isOpenUpsell) {
            const upsellEl = cartDrawerEl.querySelector('cart-drawer-upsell');

            if (upsellEl) {
              cartDrawerEl.removeAttribute('upsell-open');
              upsellEl.isOpen = true;
            }
          }
        }
      } else {
        window.location.href = '/cart';
      }
    };

    cartIcon.addEventListener('click', handleCartClick);

    cartIcon.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') handleCartClick(e);
    });
  }

  window.xCartHelper = {
    items: [],

    get currentItemCount() {
      return _s.currentItemCount;
    },

    set currentItemCount(v) {
      _s.currentItemCount = v;
    },

    get validated() {
      return _s.validated;
    },

    set validated(v) {
      _s.validated = v;
    },

    get isOpenDiscountCodeMainCart() {
      return _s.isOpenDiscountCodeMainCart;
    },

    set isOpenDiscountCodeMainCart(v) {
      _s.isOpenDiscountCodeMainCart = v;
    },

    get openField() {
      return _s.openField;
    },

    set openField(v) {
      _s.openField = v;
      _dispatch('cart:fieldchange', { field: v });
    },

    get isCopiedCart() {
      return _s.isCopiedCart;
    },

    set isCopiedCart(v) {
      _s.isCopiedCart = v;
      _dispatch('cart:copiedchange', { copied: v });
    },

    get isUpdating() {
      return _s.pendingUpdates > 0;
    },

    set isUpdating(value) {
      const checkoutBtn = document.querySelector('.cart-drawer__checkout');
      const viewCartBtn = document.querySelector('.cart-drawer__view-cart');

      if (viewCartBtn) {
        viewCartBtn.ariaDisabled = value;
      }

      if (checkoutBtn) {
        checkoutBtn.ariaDisabled = value;
      }

      _s.isUpdating = value;
    },

    beginUpdate() {
      _s.pendingUpdates++;
    },

    endUpdate() {
      _s.pendingUpdates = Math.max(0, _s.pendingUpdates - 1);
    },

    get cartShareUrl() {
      return _s.cartShareUrl;
    },

    set cartShareUrl(v) {
      _s.cartShareUrl = v;
      _dispatch('cart:shareurlchange', { url: v });
    },

    // ── Cart API ──────────────────────────────────────────────────────────

    addItems(items) {
      const cartDrawerEl = document.querySelector('#CartDrawer');
      const sectionId = cartDrawerEl?.dataset.sectionId;

      const sectionsToRender = this.getSectionsToRender(sectionId);
      const sections = sectionsToRender.map((s) => s.id);

      this.isUpdating = true;

      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items,
          sections,
        }),
      })
        .then((r) => r.json())
        .then(async (response) => {
          sectionsToRender.forEach((section) => {
            const el = document.querySelector(section.selector);

            if (el && response.sections?.[section.id]) {
              el.innerHTML = getSectionInnerHTML(
                response.sections[section.id],
                section.selector
              );
            }
          });

          /*
           * Shopify is currently returning:
           * "ajax-cart-drawer": null
           *
           * Refresh the drawer directly from the Section Rendering API
           * so the drawer always receives the current server cart HTML.
           */
          await this.refreshCartDrawer();

          document.dispatchEvent(
            new CustomEvent(CART_EVENT.cartUpdate, {
              detail: {
                openMiniCart: true,
              },
            })
          );
        })
        .catch((e) => {
          console.error('Cart add error:', e);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },

    updateCart(data, needValidate = false) {
      this.isUpdating = true;

      return fetch(Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(async () => {
          if (needValidate) {
            this.validateCart();
          }

          if (!window.Maximize?.isCartPage) {
            await this.refreshCartDrawer();
          }
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },

    changeCart(data) {
      return fetch(Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }).then((r) => r.text());
    },

    // ── Validation ────────────────────────────────────────────────────────

    validateCart() {
      this.validated = true;

      const carTerm = document.querySelector('cart-term');

      if (carTerm) {
        this.validated = carTerm._isChecked;
      }

      document.dispatchEvent(
        new CustomEvent(CART_EVENT.validate)
      );
    },

    goToCheckout(e) {
      if (this.isUpdating) {
        e.preventDefault();
        return;
      }

      this.validateCart();

      if (this.validated) {
        fetch(Shopify.routes.root + 'cart/update', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'collection-pagination': null,
              'blog-pagination': null,
              'choose_option_id': null,
              'datetime-updated': null,
              'datetime-created': null,
              [CART_ATTRIBUTES.product_comparison_options]: null,
              [CART_ATTRIBUTES.product_comparison_metafields]: null,
            },
          }),
        });
      } else {
        e.preventDefault();
      }
    },

    // ── Sections ──────────────────────────────────────────────────────────

    async refreshCartDrawer() {
      const response = await fetch('/?section_id=ajax-cart-drawer', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error('Unable to refresh cart drawer');
      }

      const html = await response.text();

      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (!newDrawer) {
        throw new Error(
          'CartDrawer was not found in ajax-cart-drawer response'
        );
      }

      if (!currentDrawer) {
        throw new Error(
          'Current CartDrawer was not found on the page'
        );
      }

      /*
       * Preserve whether the drawer is currently visible
       * before replacing its HTML.
       */
      const wasVisible =
        currentDrawer
          .querySelector('#CartDrawer__Wrapper')
          ?.classList.contains('is-visible') || false;

      currentDrawer.replaceWith(newDrawer);

      /*
       * Custom elements should reconnect automatically after replacement.
       */
      const refreshedDrawer = document.querySelector('#CartDrawer');

      if (wasVisible && refreshedDrawer) {
        refreshedDrawer
          .querySelector('#CartDrawer__Wrapper')
          ?.classList.add('is-visible');

        refreshedDrawer.isOpen = true;
      }

      await this.refreshCartCount();

      return refreshedDrawer;
    },

   async refreshMainCart() {
  const mainCart = document.querySelector('#MainCart__Items');

  if (!mainCart) return;

  const sectionId = mainCart.closest('.shopify-section')?.id
    ?.replace('shopify-section-', '');

  if (!sectionId) return;

  const response = await fetch(
    `${window.location.pathname}?section_id=${sectionId}`,
    {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Unable to refresh main cart');
  }

  const html = await response.text();

  const doc = new DOMParser().parseFromString(
    html,
    'text/html'
  );

  const newMainCart = doc.querySelector('#MainCart__Items');

  if (newMainCart) {
    mainCart.replaceWith(newMainCart);
  }

  await this.refreshCartCount();
},

getSectionsToRender(sectionId) {
  const sectionsToRender = [];

      if (window.Maximize?.isCartPage) {
        if (sectionId) {
          sectionsToRender.push({
            id: `${sectionId}`,
            selector: '#MainCart__Items',
          });
        }
      } else if (sectionId) {
        sectionsToRender.push({
          id: `${sectionId}`,
          selector: '#CartDrawer',
        });
      }

      return sectionsToRender;
    },

    // ── Share cart ────────────────────────────────────────────────────────

    generateUrl() {
      fetch(Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.json())
        .then((response) => {
          this.items = response.items;

          const serialize = (obj) =>
            Object.entries(obj)
              .reduce(
                (str, [k, v]) =>
                  str.concat(
                    `${encodeURIComponent(k)}:${encodeURIComponent(
                      v.toString()
                    )},`
                  ),
                ''
              )
              .slice(0, -1);

          const filteredCart = this.items.map((item) => ({
            id: item.variant_id,
            quantity: item.quantity,
          }));

          filteredCart.push({
            share_cart: true,
          });

          this.cartShareUrl =
            `${window.location.origin}?&` +
            filteredCart.map(serialize).join('&');
        });
    },

    copyURL() {
      const input = document.querySelector('#cart-share');

      if (input) {
        input.select();
        document.execCommand('copy');
        this.isCopiedCart = true;
      }
    },

    handleSharedCart() {
      if (!location.search.includes('share_cart')) {
        return;
      }

      const queryString = window.location.search.substring(1);

      if (!queryString.includes('share_cart:true')) {
        return;
      }

      const pairs = queryString.match(
        /id:\d+,quantity:\d+/g
      );

      if (!pairs) {
        return;
      }

      const items = pairs.map((pair) => {
        const [idPart, qtyPart] = pair.split(',');

        return {
          id: Number(idPart.split(':')[1]),
          quantity: Number(qtyPart.split(':')[1]),
        };
      });

      if (items.length) {
        this.addItems(items);
      }
    },

    // ── UI helpers ────────────────────────────────────────────────────────

async refreshCartCount() {
  const response = await fetch(Shopify.routes.root + 'cart.js', {
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Unable to refresh cart count');
  }

  const cart = await response.json();
  const count = cart.item_count || 0;

  const container = document.querySelector(
    '#cart-icon-bubble .cart-bubble__container'
  );

  if (!container) return count;

  container.dataset.countItem = count;

  let countSpan = container.querySelector('span');

  if (count > 0) {
    if (!countSpan) {
      countSpan = document.createElement('span');
      countSpan.className = 'h-full flex items-center justify-center';
      countSpan.setAttribute('aria-hidden', 'true');
      container.appendChild(countSpan);
    }

    countSpan.textContent = count < 100 ? String(count) : '99+';
  } else if (countSpan) {
    countSpan.remove();
  }

  this.currentItemCount = count;

  const headerCart = document.querySelector('.header-icon-cart');
  if (headerCart) {
    headerCart.classList.toggle('cart-empty', count === 0);
  }

  return count;
},


    updateCurrentCountItem() {
      const container = document.querySelector(
        '#cart-icon-bubble .cart-bubble__container'
      );

      this.currentItemCount = parseInt(
        container?.dataset.countItem || 0
      );
    },

    closeField(isCloseMiniCart = false) {
      this.isCopiedCart = false;

      if (isCloseMiniCart) {
        setTimeout(() => {
          this.openField = '';
        }, DURATION.DRAWER_TRANSITION);
      } else {
        this.openField = '';
      }
    },
  };

  initCartIconFallback();

  // Initialize currentItemCount from server-rendered DOM.
  window.xCartHelper.updateCurrentCountItem();
})();